export default "__VITE_PUBLIC_ASSET__f0946563__"